var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-default-app-bar',{attrs:{"back-to":true}},[_vm._v(" "+_vm._s(_vm.titulo)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }